import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Mail } from "lucide-react";
import { Container, PageFade } from "../components/site/Motion";
import { ConsultationSection } from "../components/site/ConsultationSection";
import { FaqAccordion } from "../components/site/Sections";
import { api, store } from "../lib/api";
import { CONTACT_EMAIL } from "../i18n/fr";

export default function Consultation() {
  const [params] = useSearchParams();
  const slug = params.get("forfait");
  const [forfait, setForfait] = useState(null);
  const result = store.get("struktiv_result");
  useEffect(() => {
    if (slug) api.get(`/forfaits/${slug}`).then((r) => setForfait(r.data)).catch(() => setForfait(null));
  }, [slug]);
  const leadId = result && result.recommendation?.forfait_slug === slug ? result.lead_id : null;

  return (
    <PageFade>
      <ConsultationSection forfait={forfait} leadId={leadId} />
      <Container className="grid gap-12 py-16 lg:grid-cols-[1fr_1.6fr] lg:py-24">
        <div className="space-y-5" data-testid="contact-info">
          <p className="eyebrow">Nous contacter</p>
          <h2 className="text-3xl">Une question avant de réserver?</h2>
          <a href={`mailto:${CONTACT_EMAIL}`} className="inline-flex items-center gap-3 text-[#650D23]" data-testid="contact-email-link"><Mail className="h-5 w-5" />{CONTACT_EMAIL}</a>
          <p className="text-sm text-[#242020]/60">La réservation en ligne par calendrier sera ajoutée prochainement. En attendant, un membre de l'équipe vous contacte pour fixer un moment.</p>
        </div>
        <FaqAccordion />
      </Container>
    </PageFade>
  );
}
